import { faCheckSquare, faClipboardCheck, faFileContract, faFileInvoice, faFilePrescription, faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import { Check2Square, DashCircle, FileEarmarkCheck } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function ModalBihamtaGuarantee({ modalData, setModalData }) {

    const history = useHistory();
    const remainedDays = Number(modalData?.RemainedDays);
    if (!modalData?.show || remainedDays > 90) {
        return null;
    }
    let endText = "گارانتی نرم افزار ";
    if (remainedDays === 0) {
        endText += "امروز ";
    }
    else {
        endText += "در تاریخ " + modalData.PExpDate;
    }
    if (remainedDays >= 0) {
        endText += " به پایان می‌رسد";
    }
    else {
        endText += " به پایان رسیده است.";
    }
    function handleCancel() {
        setModalData({ show: false });
        modalData.onClose?.();
    }
    function handleExtend() {
        modalData.onClose?.();
        history.push("/GuaranteeExtend");
    }
    return (

        <Modal show={modalData.show}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faFileContract} size="lg" />&nbsp;
                    گارانتی نرم افزار
                </span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <ul>
                    <li>
                        گارانتی نرم افزار{" "}
                        {remainedDays !== 0 && (
                            <>
                                در تاریخ <strong>{modalData.PExpDate}</strong>{" "}
                            </>
                        )}
                        {remainedDays === 0 && "امروز"}
                        {remainedDays >= 0 && "به پایان می‌رسد."}
                        {remainedDays < 0 && "به پایان رسیده است."}
                    </li>

                    {remainedDays > 0 && (
                        <li>
                            {remainedDays <= 30 && "تنها "}
                            <span
                                className="opacity-animation"
                                style={{ fontWeight: 900 }}
                            >
                                {remainedDays}
                            </span>
                            {" روز به پایان گارانتی باقی مانده است."}
                        </li>
                    )}

                    {remainedDays === 0 && (
                        <li>
                            گارانتی{" "}
                            <span
                                className="opacity-animation"
                                style={{ fontWeight: 900 }}
                            >
                                امروز
                            </span>{" "}
                            به پایان می‌رسد.
                        </li>
                    )}

                    {remainedDays < 0 && (
                        <li>
                            <span
                                className="opacity-animation"
                                style={{ fontWeight: 900 }}
                            >
                                {Math.abs(remainedDays)}
                            </span>{" "}
                            روز از پایان گارانتی گذشته است.
                        </li>
                    )}

                    {remainedDays > 0 && (
                        <li>
                            اکنون اقدام کنید تا از{" "}
                            <span
                                className="heart-animation"
                                style={{ color: "#a81111", fontWeight: 900 }}
                            >
                                {modalData.DiscountPercent}%
                            </span>{" "}
                            تخفیف بهره‌مند شوید.
                        </li>
                    )}
                </ul>
                <div>
                    <Button variant="info" className="group-Btn" onClick={handleExtend}><Check2Square size={18} /> تمدید گارانتی</Button>
                    <Button variant="danger" className="group-Btn" onClick={handleCancel}><DashCircle size={18} /> انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}